import React, { Component } from 'react'
import './style.css'
export default class Or extends Component {
  render() {
    return (
        <div className="or">or</div>
    )
  }
}
